// extracted by mini-css-extract-plugin
module.exports = {"container":"_89b4965636--container--bLDYe","slider":"_89b4965636--slider--c_mUD","carousel":"_89b4965636--carousel--B_IeL","slide":"_89b4965636--slide--IxNDI"};